module.exports = __webpack_public_path__ + "static/media/fly0120.ab9de4f0.webp";